import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'

import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { ISupplierOutPutDTO } from 'src/services/reservation/supplier/supplierDTO'

class SupplierServices {
  async getByParam(params: object): Promise<ISupplierOutPutDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/supplier/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const supplierServices = new SupplierServices()
